<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>

  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="width" [height]="height"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình format font name của button -->
      <li nz-submenu nzTitle="{{'dinh_dang_ten_nut' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="container-font">
          <div class="config-text" style="width: 100%">
            <!-- Nhập nội dung của nút -->
            <mat-form-field style="width: 100%">
              <mat-label> {{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('content');"></textarea>
            </mat-form-field>
            <!-- Nếu nội dung không có thì phải có nhãn -->
            <mat-form-field style="width: 100%" class="aria-label-input" [matTooltip]="'*_giai_thich_aria_label' | translate"
            *ngIf="!staticdata['content_' + functionService.selectedLanguageCode]?.trim()">
              <mat-label>{{'nhan_cua_nut' | translate}}<span style="color: red">*</span></mat-label>
              <textarea matInput
                [ngModel]="staticdata.accessibility?.['aria_label_' + functionService.selectedLanguageCode]"
                (ngModelChange)="staticdata.accessibility['aria_label_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateContent('aria_label', true);"></textarea>
            </mat-form-field>
          </div>
          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
             [staticdata]="staticdata" [textContentClass]="class['button__content']"
            [textWrapperClass]="class['button']">
          </app-text-format-config>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                  class['button__content']['letter-spacing'] | vhnumber
                " (nzBlur)="updateClass()" (ngModelChange)="
                  class['button__content']['letter-spacing'] = $event + 'px'
                "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30" [ngModel]="class['button__content']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="
                class['button__content']['letter-spacing'] = $event + 'px'
              "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title"> {{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['button__content']['line-height']" (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1" [(ngModel)]="class['button__content']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>

          <label class="px-1">{{'gian_cach' | translate}}</label>
          <div class="padding">
            <div class="d-flex items">
              <img src="./assets/root/images/system/icons/padding-top.svg" alt="1" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [ngModel]="class['button']['padding-top'] | vhnumber"
                (nzBlur)="updateClassAndWidthHeight();updateDimension()" (ngModelChange)="
                  class['button']['padding-top'] = $event + 'px';
                  class['button']['padding-bottom'] = $event + 'px'
                "></nz-input-number>
            </div>
            <div class="d-flex items">
              <img src="./assets/root/images/system/icons/padding-right-left.svg" alt="1" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [ngModel]="class['button']['padding-left'] | vhnumber"
                (nzBlur)="updateClassAndWidthHeight();updateDimension()" (ngModelChange)="
                  class['button']['padding-right'] = $event + 'px';
                  class['button']['padding-left'] = $event + 'px'
                "></nz-input-number>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình màu nền của button -->
      <li nz-submenu nzTitle="{{'mau_sac' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <div class="container-color">
          <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{ 'background-color': background.bgColor }" (click)="chooseBg(background, $event)" nz-tooltip
            [disabled]="config['background-color'].gradient_check"></button>
        </div>
        <div class="color-pick">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input class="input-color w-50" type="button" [cpOKButton]="true"
            [(colorPicker)]="class['button']['background-color']"
            [style.background]="class['button']['background-color']" (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
            [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
            [cpPresetLabel]="'bang_mau_mau' | translate" [disabled]="config['background-color'].gradient_check"
            [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
            (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
        </div>
        <div class="mr-2 mb-4 mt-4 view-more" style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          ">
          <p class="discover_text" (click)="openViewAll(styles_field[3])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
        <!-- Mở popup so sánh màu tương phản -->
        <button *ngIf="staticdata['content_' + functionService.selectedLanguageCode]"
        nz-row (click)="openColorContrast()" nz-tooltip
        [nzTooltipTitle]="'dung_de_toi_uu_chi_so_accessibility_kha_nang_tiep_can_tren_pagespeed' | translate"
        style="color: #fff; background-color: #00a859; width: 100%; padding: 8px; border-radius: 8px;">
          {{ 'so_sanh_do_tuong_phan_giua_mau_chu_icon_va_mau_nen' | translate }}
        </button>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['button']"
          [fontSizeIconClass]="class['button__content--icon']" [symbolConfig]="config['flex-direction']"
          [objectChoosing]="objectChoosing">
        </app-symbol-config>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['button']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['button']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <div class="d-flex justify-content-between align-items-center mb-2 mt-1"
        style="gap: 8px;">
          <p>{{'dong_bo_hieu_ung_di_chuot_voi_khung_ngoai' | translate}}</p>
          <nz-switch [ngModel]="config.is_group_hover" 
            (ngModelChange)="toggleGroupHover($event)">
          </nz-switch>
        </div>
        <ng-container *ngIf="config.is_group_hover">
          <div class="d-flex justify-content-between align-items-center">
            <p class="w-50">{{'mau_nen' | translate}}</p>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['button--hover']['background-color']"
              [style.background]="class['button--hover']['background-color']"
              [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
              (colorPickerClose)="updateClass()" 
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)"
            />
          </div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <p class="w-50">{{'mau_chu' | translate}}</p>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['button__content--hover'].color"
              [style.background]="class['button__content--hover'].color"
              [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
              (colorPickerClose)="updateClass()" 
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)"
            />
          </div>
          <div class="d-flex justify-content-between align-items-center mt-2">
            <p class="w-50">{{'mau_bieu_tuong' | translate}}</p>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['button__content--icon-hover'].color"
              [style.background]="class['button__content--icon-hover'].color"
              [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"
              (colorPickerClose)="updateClass()" 
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)"
            />
          </div>
        </ng-container>
        <ng-container *ngIf="!config.is_group_hover">
          <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
            [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [cursorClass]="class['button']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
            [effectFileUsing]="'button'">
          </app-choose-animations-config>
        </ng-container>
      </li>
      <!-- Cấu hình thêm liên kết -->
      <li *ngIf="!objectChoosing.dynamic_data" nz-submenu nzTitle="{{'lien_ket' | translate}}"
        [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <app-link-page-config 
          [type_page]="objectChoosing.component == 'AtwButtonViewDetailCategory' ? ['detail_category'] : ['detail_product']" 
          [staticdata]="staticdata"
          [id_object]="objectChoosing._id"
        ></app-link-page-config>
      </li>
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['button']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"
        [device]="device"></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"></label>
      </div>
      <div class="list-gradient">
        <button class="btn-gradient" *ngFor="
            let bgGradient of config['background-color']['gradient_arr'];
            let i = index
          " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color'].gradient_check">
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{'them_mau' | translate}}</p>
      <div class="container_add-gradient">
        <input class="input-color" [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']"
          type="button" [disabled]="!config['background-color'].gradient_check"
          [style.background]="class['button']['background-color']" (colorPickerClose)="addGradient($event)"
          [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
          [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
          [cpPresetLabel]="'bang_mau_mau' | translate" [disabled]="config['background-color'].gradient_check"
          [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate" [cpPresetColors]="themeService.themeColors"
          (cpPresetColorsChange)="themeService.presetColorsChange($event)" />
      </div>
      <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
      <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip [nzTooltipTitle]="type.name"
        (click)="chooseOption(type, $event)" [disabled]="!config['background-color'].gradient_check" [style.background]="
          'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
        "></button>
    </div>
  </div>
</div>